<template>
  <div class="dangJianShe">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="true" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">

        <el-col :span="12">
          <el-form-item label="是否设置基层党组织"  ref="is_build_zuzhi" prop="is_build_zuzhi">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_build_zuzhi" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="tips">
                <i class="iconfont icon-xinxitishi"></i>注：包括党支部、党小组、流动党支部等党的组织
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_build_zuzhi == 1">
          <el-form-item label="党组织设置形式" ref="build_type" prop="build_type">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.build_type" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in dangXingShiOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_build_zuzhi == 1">
          <el-form-item label="隶属关系" ref="lishu_guanxi" prop="lishu_guanxi">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.lishu_guanxi" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in lisHUgUANxIOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.lishu_guanxi == 12">
          <el-form-item label="其他隶属关系" ref="lishu_guanxi_other" prop="lishu_guanxi_other">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.lishu_guanxi_other" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机构党员数量" ref="dagnyuan_num" prop="dagnyuan_num">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.dagnyuan_num" class="inp"></el-input>
              <div class="tips">
                <i class="iconfont icon-xinxitishi"></i>注：请填写在本机构签订劳动合同的正式党员人数
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="flex justify-start align-center">
            <div class="flex-sub flex-sub-w0">
              <el-form-item label="是否将党建工作纳入章程" ref="is_naru_zhangcheng" prop="is_naru_zhangcheng">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.is_naru_zhangcheng" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="tips">
                    <i class="iconfont icon-xinxitishi"></i>注：在公司章程中，明确“坚持党的领导”等党建工作内容。
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-form-item class="errorTips" v-if="ruleForm.is_naru_zhangcheng == 1" ref="zhangcheng" prop="zhangcheng">
              <div class="flex justify-start align-center">
                <a :href="ruleForm.zhangcheng" v-if="ruleForm.zhangcheng" target="_blank" class="look">查看附件</a>
                <upload-file
                  v-if="false"
                  class="upZuj"
                  name="zhangcheng"
                  @uploadFile="uploadFile"
                >
                  <div class="btnUp" slot="upload">
                    <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                  </div>
                </upload-file>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
<!--    <div class="btn-box">-->
<!--      <div class="btn" @click="submitForm('ruleForm')">保存</div>-->
<!--    </div>-->
  </div>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {dangXingShiOptions, isYes, lisHUgUANxIOptions} from "@/utils/const";
import UploadFile from "@/components/UploadFile";
import {
  save_dangyuan,
  get_yunying
} from '@/api/admin';
export default {
  name: "dangJianShe",
  data() {
    return {
      org_id:'',
      isYes: isYes,
      dangXingShiOptions:dangXingShiOptions,
      lisHUgUANxIOptions:lisHUgUANxIOptions,
      ruleForm: {
        dagnyuan_num: '', // 党员数量
        is_build_zuzhi: '', // 党员数量
        build_type: '', // 党组织设置形式
        lishu_guanxi: '', // 隶属关系
        lishu_guanxi_other: '', // 其他隶属关系
        is_naru_zhangcheng: '', // 是否将党建工作纳入章程
        zhangcheng:'' // 章程附件
      },
      rules: {
        parent_zuzhi_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        zuzhi_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        lishu_guanxi_other: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        dagnyuan_num: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        is_build_zuzhi: [
          {required: false, message: '请输入', trigger: 'change'}
        ],
        lishu_guanxi:[
          {required: false, message: '请选择', trigger: 'change'}
        ],
        build_type:[
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_naru_zhangcheng:[
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zhangcheng:[
          {required: false, message: '请上传', trigger: 'change'}
        ]
      }
    }
  },
  components: {UploadFile},
  created() {
    this.org_id = this.$route.query.org_id
    this.init()
  },
  methods: {
    async init(){
      let _data = await get_yunying(this.org_id,1);
      if(_data.status == 200){
        this.ruleForm = {
          dagnyuan_num: _data.data.dagnyuan_num, // 党员数量
            is_build_zuzhi: _data.data.is_build_zuzhi, // 党员数量
          build_type:  _data.data.build_type, // 党组织设置形式
          lishu_guanxi:  _data.data.lishu_guanxi, // 隶属关系
          lishu_guanxi_other:  _data.data.lishu_guanxi_other, // 其他隶属关系
            is_naru_zhangcheng: _data.data.is_naru_zhangcheng, // 是否将党建工作纳入章程
            zhangcheng:_data.data.zhangcheng // 章程附件
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },

    async submitInfo() {
      let _data = await save_dangyuan(
        this.org_id,
        this.ruleForm.dagnyuan_num,
        this.ruleForm.is_build_zuzhi,
        this.ruleForm.build_type,
        this.ruleForm.lishu_guanxi,
        this.ruleForm.lishu_guanxi_other,
        this.ruleForm.is_naru_zhangcheng,
        this.ruleForm.zhangcheng
      );
      if (_data.status === 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    uploadFile(data) {
      this.ruleForm[data.name] = data.file.url
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {
  .width {
    width: 400px;
  }



  .add {
    width: 36px;
    margin-left: 10px;
    margin-top: 15px;
    cursor: pointer;
  }

  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
    margin-top: 15px;
  }

  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }
  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }
}
</style>


